/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/const/TimeFactor.ts
 * @create:      2025-06-29 08:51:29.862
 * @modify:      2025-07-11 21:19:12.916
 * @version:     6.0.0
 * @times:       22
 * @lines:       62
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

export const MillisecondsPerSecond = 1000;
export const MillisecondsPerMinute = 60 * MillisecondsPerSecond;
export const MillisecondsPerHour = 60 * MillisecondsPerMinute;
export const MillisecondsPerDay = 24 * MillisecondsPerHour;
export const MillisecondsPerWeek = 7 * MillisecondsPerDay;

export const SecondsPerMillisecond = 1 / MillisecondsPerSecond;
export const SecondsPerMinute = 60;
export const SecondsPerHour = 60 * SecondsPerMinute;
export const SecondsPerDay = 24 * SecondsPerHour;
export const SecondsPerWeek = 7 * SecondsPerDay;

export const MinutesPerMillisecond = 1 / MillisecondsPerMinute;
export const MinutesPerSecond = 1 / SecondsPerMinute;
export const MinutesPerHour = 60;
export const MinutesPerDay = 24 * MinutesPerHour;
export const MinutesPerWeek = 7 * MinutesPerDay;

export const HoursPerMillisecond = 1 / MillisecondsPerHour;
export const HoursPerSecond = 1 / SecondsPerHour;
export const HoursPerMinute = 1 / MinutesPerHour;
export const HoursPerDay = 24;
export const HoursPerWeek = 7 * HoursPerDay;

export const DaysPerMillisecond = 1 / MillisecondsPerDay;
export const DaysPerSecond = 1 / SecondsPerDay;
export const DaysPerMinute = 1 / MinutesPerDay;
export const DaysPerHour = 1 / HoursPerDay;
export const DaysPerWeek = 7;
